// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__I122q","button":"Button_button__zPrsI","button_disable":"Button_button_disable__g0I+m"};